import React from 'react'
import { createStyles, Typography, withStyles } from '@material-ui/core'
import { expandFooterLinks } from './styles'

const styles = (theme) => {
  return createStyles({
    section: {
      marginBottom: '4rem',
      [theme.breakpoints.up(expandFooterLinks)]: {
        marginBottom: 0,
      },
      '& + &': {
        [theme.breakpoints.up(expandFooterLinks)]: {
          marginLeft: '3rem',
        },
      },
    },
    title: {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    list: {
      padding: 0,
    },
  })
}

const Section = ({ classes, title, children }) => {
  return (
    <div className={classes.section}>
      <Typography variant="h2" className={classes.title}>
        {title}
      </Typography>
      <ul className={classes.list}>{children}</ul>
    </div>
  )
}

export default withStyles(styles)(Section)
